import { useAtomValue, useSetAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { unwrappedMarkersDescriptionsAtom } from '@/atoms/eventMarkers';
import { eventLinkAtom } from '@/atoms/navigation';
import { resultRectAtom, selectVisEventsAtom } from '@/atoms/vis/selection';
import { isStartPlacementAtom } from '@/atoms/visualisation';
import useGetLinkPath from '@/hooks/useGetLinkPath';
import { SelectionRect } from '@/types/selection';
import { UnwrappedPitchEventsAtom } from '@/types/visualisation';
import { getSelectedMarkersAndArrows } from '@/utils/atoms/vis';

export const useDragEndSelectEvents = (unwrappedPitchEventsAtom: UnwrappedPitchEventsAtom) => {
  const pitchEvents = useAtomValue(unwrappedPitchEventsAtom);
  const markersDescriptions = useAtomValue(unwrappedMarkersDescriptionsAtom);
  const isStartPlacement = useAtomValue(isStartPlacementAtom);
  const setResultRect = useSetAtom(resultRectAtom);
  const selectVisEvents = useSetAtom(selectVisEventsAtom);
  const { to, relative } = useGetLinkPath(eventLinkAtom);
  const navigate = useNavigate();

  return (rect: SelectionRect) => {
    setResultRect(rect);

    const selectedMarkersAndArrows = getSelectedMarkersAndArrows(rect, pitchEvents, isStartPlacement);
    const selectedIds = new Set(selectedMarkersAndArrows.map(marker => marker.eventId));
    selectVisEvents(
      selectedMarkersAndArrows,
      markersDescriptions.filter(({ eventId }) => selectedIds.has(eventId)),
    );

    if (selectedMarkersAndArrows?.length > 0) navigate(to, { relative });
  };
};
